module.exports = __webpack_public_path__ + "img/eating-out.8b603c34.svg";